import { ActionItem, ActionType } from '../../components/Actions/types'
import { POI, Scene } from '../types'

interface GenActionsOptions {
  pois?: POI[]
  scenes?: Scene[]
  sceneMap?: Record<string, Scene> // optionally support keyed objects
}

export function generateActions({
  pois = [],
  scenes = [],
  sceneMap = {},
}: GenActionsOptions): ActionItem[] {
  const poiActions: ActionItem[] = pois.map((poi) => ({
    id: poi.id,
    label: poi.key ? `${poi.key}: ${poi.name}` : (poi?.name ?? poi.id),
    fullData: poi,
    type: ActionType.POI,
    visited: poi?.visited,
    locked: poi?.locked,
  }))

  const sceneActions: ActionItem[] = scenes.map((scene) => ({
    id: scene.id,
    label: scene.action ?? scene.name ?? scene.id,
    fullData: scene,
    type: ActionType.SCENE,
    visited: scene?.visited,
    locked: scene?.locked,
  }))

  const sceneMapActions: ActionItem[] = Object.values(sceneMap).map(
    (scene) => ({
      id: scene.id,
      label: scene.action ?? scene.name ?? scene.id,
      fullData: scene,
      type: ActionType.SCENE,
      visited: scene?.visited,
      locked: scene?.locked,
    })
  )

  return [...poiActions, ...sceneActions, ...sceneMapActions]
}
